module.exports = __webpack_public_path__ + "static/media/Jatinder.6fcdfd33.jpg";